import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";
import { LogIn, ArrowLeft } from "lucide-react";
import Seo from "@/components/Seo";

export default function Login() {
  const { login } = useAuth();
  const nav = useNavigate();
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    if (loading) return;
    setLoading(true);
    try {
      const u = await login(email, password);
      toast.success(`Bienvenue ${u.name}`);
      nav("/app");
    } catch (err) {
      const msg = err?.response?.data?.detail || "Erreur de connexion";
      toast.error(typeof msg === "string" ? msg : "Erreur de connexion");
    } finally { setLoading(false); }
  };

  return (
    <div className="min-h-screen flex flex-col lg:flex-row bg-white text-[#1a2332] font-body" data-testid="login-page">
      <Seo title="Espace membre — Connexion | DDSBillancourt" path="/login" noindex />
      <div className="lg:w-1/2 relative overflow-hidden p-8 lg:p-16 flex flex-col justify-between bg-[#080C0E] text-white">
        <Link to="/" className="inline-flex items-center gap-2 text-white/70 hover:text-white w-fit" data-testid="back-home">
          <ArrowLeft className="w-4 h-4" /> Retour au site
        </Link>
        <div>
          <img src="/brand/logo.png" alt="DDSEmpire" className="w-16 h-16 rounded-xl object-contain" />
          <h1 className="mt-8 font-headings font-black text-4xl md:text-5xl leading-tight">Plateforme<br/>DDSEmpire.</h1>
          <p className="mt-5 text-white/65 max-w-md text-lg">Accès réservé aux élèves, mentors et administrateurs de Dynastie Drive School.</p>
        </div>
        <div className="text-xs text-white/50">
          DDSEmpire · 37 Av. Édouard Vaillant, 92100 Boulogne-Billancourt · 01 41 31 50 61
        </div>
      </div>

      <div className="lg:w-1/2 flex items-center justify-center p-8">
        <form onSubmit={submit} className="w-full max-w-sm" data-testid="login-form">
          <h2 className="font-headings font-black text-3xl">Connexion</h2>
          <p className="mt-2 text-[#5b6577]">Saisissez les identifiants fournis par votre auto-école.</p>

          <label className="block mt-8">
            <span className="font-headings font-semibold text-sm">Email</span>
            <input type="email" required value={email} onChange={(e)=>setEmail(e.target.value)} data-testid="login-email"
              className="mt-2 w-full rounded-xl border-2 border-[#e5eaf3] focus:border-[#00a86b] outline-none px-4 py-3 font-body" placeholder="vous@ddsbillancourt.fr" />
          </label>
          <label className="block mt-4">
            <span className="font-headings font-semibold text-sm">Mot de passe</span>
            <input type="password" required value={password} onChange={(e)=>setPassword(e.target.value)} data-testid="login-password"
              className="mt-2 w-full rounded-xl border-2 border-[#e5eaf3] focus:border-[#00a86b] outline-none px-4 py-3 font-body" placeholder="••••••••" />
          </label>
          <button type="submit" disabled={loading} data-testid="login-submit"
            className="mt-6 w-full inline-flex items-center justify-center gap-2 bg-[#FF8C42] hover:bg-[#e8763a] disabled:opacity-60 text-white font-headings font-bold rounded-xl px-7 py-3.5 shadow-lg transition-all">
            {loading ? "Connexion…" : (<>Se connecter <LogIn className="w-4 h-4" /></>)}
          </button>
          <div className="mt-4 text-center">
            <Link to="/mot-de-passe-oublie" data-testid="login-forgot-link" className="text-sm text-[#00a86b] hover:underline font-headings font-semibold">
              Mot de passe oublié ?
            </Link>
          </div>
          <p className="mt-6 text-xs text-[#5b6577]">
            Problème de connexion ? Contactez l'auto-école au 01 41 31 50 61.
          </p>
        </form>
      </div>
    </div>
  );
}
